module.exports = __webpack_public_path__ + "static/img/Progressed.f05357dd.png";